/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserProfilePutSpec { 
    /**
     * Internal username from JWT (e.g., dk016191@broadcom.net)
     */
    internal_username: string;
    /**
     * User\'s actual email address (e.g., dhruv.khatri@broadcom.com)
     */
    email: string;
    /**
     * User\'s first name
     */
    first_name?: string;
    /**
     * User\'s last name
     */
    last_name?: string;
}

